import styled from 'styled-components';

export const Container = styled.span`
  display: inline-block;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  margin: ${({ theme }) => theme.spacing.md} 0;
  background-color: ${({ theme }) => theme.colors.N60};
  color: ${({ theme }) => theme.colors.N20};
  float: right;
  font-family: Courier;
`;
